import { render, staticRenderFns } from "./webAIagent.vue?vue&type=template&id=0f368c6d&scoped=true&"
import script from "./webAIagent.vue?vue&type=script&lang=js&"
export * from "./webAIagent.vue?vue&type=script&lang=js&"
import style0 from "./webAIagent.vue?vue&type=style&index=0&id=0f368c6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f368c6d",
  null
  
)

export default component.exports